import CloseBlackIcon from 'assets/ver2/icons/close-black-icon.svg';
import CloseWhiteIcon from 'assets/ver2/icons/close-white-icon.svg';
import { IFRAME_RESIZE_LOG, LogUtil } from 'components/common/LogUtil';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  MOBILE_SMALL_MIN_WIDTH,
  SCREEN_ID_REFERENCE_PATH,
  SCREEN_ID_REFERENCE_PATH_MOBILE,
  TABLET_MIN_WIDTH,
} from 'constants';
import { Fade } from 'helpers/animation';
import useAuth from 'hooks/useAuth';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const withIframeResizer = (Component) => {
  const IframeResizerComponent = (props) => {
    let {
      name,
      isOpen,
      onClose,
      onClick,
      modalStyles,
      modalOptions,
      isBackdropOverlap,
      zIndexBackdropOverlap,
      zIndexModal = 0,
    } = props || {};

    const { token } = useAuth();
    const navigate = useNavigate();
    const { isDesktop } = useDetectDevice();

    const [isHidden, setHidden] = useState(true);
    const [isShowCloseBtn, setShowCloseBtn] = useState(false);
    const [isTriggerFullScreen, setTriggerFullScreen] = useState(false);

    const iframeRef = useRef(null);

    const {
      iframeSrc,
      action1Name,
      action2Name,
      isFullScreen,
      isFullScreenWithHeader,
    } = modalOptions || {};

    useEffect(() => {
      LogUtil.log(IFRAME_RESIZE_LOG, `${name} 🚀🚀🚀 RUNNING ...`);
      if (!isFullScreen) return;
      setTriggerFullScreen(!iframeSrc?.includes('/description'));
    }, []);

    modalStyles = {
      ...modalStyles,
      ...(!isDesktop &&
        isTriggerFullScreen && {
          borderRadius: 0,
        }),
    };

    const onReady = (iFrameResizer) => {
      try {
        if (isEmpty(iFrameResizer)) return;
        LogUtil.log(IFRAME_RESIZE_LOG, 'onReady');
        console.log(`⚙️ iFrameResizer ↩`, iFrameResizer);
        iFrameResizer.sendMessage({ token });
      } catch (error) {
        LogUtil.error(IFRAME_RESIZE_LOG, 'onReady >>> ERROR', error?.message);
      }
    };
    const onMessage = (data) => {
      if (isEmpty(iframeRef)) return;
      LogUtil.log(IFRAME_RESIZE_LOG, 'onMessage');
      console.log(`🚀 listening iframe message ↩`, data);
      const { message: eventMessage } = data || {};
      const { message, type, isTriggerFullScreen } = eventMessage || {};
      const { action, screenId, success } = message || {};

      if (eventMessage?.hasOwnProperty('isTriggerFullScreen') && !isDesktop) {
        setTriggerFullScreen(isTriggerFullScreen === 'true');
      }

      if (!isEmpty(action1Name) && action === action1Name) {
        onClose();
      }
      if (!isEmpty(action2Name) && action === action2Name) {
        onClick();
      }

      if (screenId) {
        if (isDesktop) {
          navigate(SCREEN_ID_REFERENCE_PATH[screenId]);
        } else {
          navigate(SCREEN_ID_REFERENCE_PATH_MOBILE[screenId]);
        }
        onClose();
      }

      if (!message?.hasOwnProperty('success')) {
        setShowCloseBtn(true);
      }
    };
    const onResized = (e) => {
      if (isEmpty(iframeRef)) return;
      const { iframe, type } = e || {};
      if (isEmpty(iframe)) return;
      LogUtil.log(IFRAME_RESIZE_LOG, 'onResized xxxx type ➡️', type);
      setHidden(false);
    };

    const renderCloseButton = () => {
      if (!isShowCloseBtn) return null;
      return (
        <CloseIconStyled
          src={isTriggerFullScreen ? CloseWhiteIcon : CloseBlackIcon}
          width={30}
          height={30}
          onClick={onClose}
          $isFullScreen={isTriggerFullScreen}
        />
      );
    };

    const newProps = {
      ...props,
      iframeRef,
      iframeSrc,
      isTriggerFullScreen,
      onReady,
      onMessage,
      onResized,
    };

    if (!iframeSrc) return null;
    return (
      <>
        <style>
          {zIndexModal
            ? `
            .modal {
              z-index: ${zIndexModal || 1101};
            }
        `
            : ``}
          {isBackdropOverlap
            ? `
          .event-iframe-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
            : `
        .event-iframe-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
        </style>
        <ModalStyled
          show={isOpen}
          onHide={() => {}}
          aria-labelledby="contained-modal-title-vcenter"
          backdropClassName="event-iframe-modal-backdrop"
          centered
          $styles={modalStyles}
          $isFullScreen={isTriggerFullScreen}
          $isFullScreenWithHeader={isFullScreenWithHeader}
          $isHidden={isHidden}
        >
          {renderCloseButton()}
          <Component {...newProps} />
        </ModalStyled>
      </>
    );
  };
  return IframeResizerComponent;
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 0px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      margin-inline: auto;
      border: none;
      width: calc(100dvw - 32px);
      border-radius: ${(props) => props.$styles?.borderRadius}px!important;
      opacity: ${(props) => props.$isHidden && '0'};
      ${(props) =>
        !props.$isHidden &&
        `
        ${Fade}
      `}
    }
  }

  @media screen and (max-width: ${MOBILE_MAX_WIDTH}px) {
    & .modal-dialog {
      ${(props) =>
        props.$isFullScreen &&
        `
      margin: 0;
      padding: 0;
      `}
      & .modal-content {
        ${(props) =>
          props.$isFullScreen &&
          `
          height: ${
            props.$isFullScreenWithHeader ? 'calc(100dvh - 70px)' : '100dvh'
          };
          top: ${props.$isFullScreenWithHeader && '43px!important'};
          width: 100dvw;
        `}
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      & .modal-content {
        width: ${(props) => props.$styles?.width}px;
      }
    }
  }

  @media screen and (min-width: ${MOBILE_SMALL_MIN_WIDTH}px) and (max-width: ${TABLET_MIN_WIDTH}px) {
    & .modal-dialog {
      ${(props) =>
        props.$isFullScreen &&
        `
        max-width: 100dvw!important; 
      `}
    }
  }
`;

const CloseIconStyled = styled.img`
  position: absolute;
  border-radius: 50%;
  cursor: pointer;
  ${(props) =>
    props.$isFullScreen
      ? `
        top: 8px;
        right: 8px;
        background: #000;
      `
      : `
        top: -34px;
        right: 0px;
        background: #fff;
        padding: 2px;
      `}
`;

export default withIframeResizer;
